import React from 'react';

import * as styles from './NoteModalLayout.css';

type TProps = {
  textarea: React.ReactNode;
  buttons: React.ReactNode;
};

export const NoteModalLayout: React.FC<TProps> = ({ textarea, buttons }) => {
  return (
    <div className={styles['container']}>
      {textarea}
      <div className={styles['buttons']}>{buttons}</div>
    </div>
  );
};
